import { WORKSPACE_FRAGMENT } from 'features/workspace'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { UserDTO } from '../types/userDTO'

export const USER_FRAGMENT: TypedDocumentNode<UserDTO> = gql`
  ${WORKSPACE_FRAGMENT}

  fragment UserFragment on User {
    createdAt
    currentWorkspace {
      ...WorkspaceFragment
    }
    currentWorkspaceRole
    email
    features {
      enabled
      name
    }
    firstName
    id
    lastName
    role
    updatedAt
    workspaceProducts {
      product
      status
    }
    workspaces {
      ...WorkspaceFragment
    }
  }
`
